import { Trans } from "react-i18next";

export const messageErrorCode = (code) => {
  if (code === 5500040) {
    return <Trans i18nKey="cofidispay.error5500040" components={{ br: <br />, small: <small /> }} />;
  }
  if (code === 5500041) {
    return <Trans i18nKey="cofidispay.error5500041" components={{ br: <br />, small: <small /> }} />;
  }
  if (code === 5500042) {
    return <Trans i18nKey="cofidispay.error5500042" components={{ br: <br />, small: <small /> }} />;
  }
  if (code === 5500043) {
    return <Trans i18nKey="cofidispay.error5500043" components={{ br: <br />, small: <small /> }} />;
  }
  return <Trans i18nKey="cofidispay.errorDefault" components={{ br: <br /> }} />;
};
